

import 'keen-slider/keen-slider.min.css';
import KeenSlider from 'keen-slider';
import { debounce } from '~/mixins/helpers';

export default {
  name: 'BrandSlider',
  props: {
    popularCollections: {
      type: Array,
      default() { return []; },
    },
    popularCollectionsAll: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      slider: null,
      current: 0,
      activeSliders: 5,
      slidersLength: 0,
      arrowDisabled: true,
      defaultIdx: 0,
      beforeElement: false,
      afterElement: false,
      isImagesLoaded: false,
    };
  },
  computed: {
    lastSlide() {
      return this.popularCollections.length + 1;
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
  },
  methods: {
    initSlider() {
      const slider = this.$refs.container?.querySelector('.collection-slider');
      if (!slider) {
        return;
      }
      // if (window.innerWidth < 1680) {
      //   this.activeSliders = 4;
      // } else {
      //   this.activeSliders = 5;
      // }
      this.slider = new KeenSlider(slider, {
        initial: this.defaultIdx,
        mode: 'free',
        disabled: false,
        slides: {
          // perView: this.activeSliders,
          perView: 'auto',
          spacing: 12,
        },
        breakpoints: {
          '(min-width: 1024px)': {
            disabled: false,
            mode: 'snap',
            slides: {
              perView: 3.88,
              spacing: 12,
            },
          },
          '(min-width: 1264px)': {
            disabled: false,
            mode: 'snap',
            slides: {
              perView: 4.88,
              spacing: 12,
            },
          },
          '(min-width: 1680px)': {
            disabled: false,
            mode: 'snap',
            slides: {
              perView: 5.88,
              spacing: 12,
            },
          },
        },
        slideChanged: (s) => {
          this.current = s.track.details.rel;
        },
        created: () => {
          this.$refs.container.classList.add('isCreated');
          this.centerArrows();
        },
        destroyed: () => {
          this.$refs.container.classList.remove('isCreated');
          this.$refs.container.classList.add('isDestroyed');
        },
      });

      this.slidersLength = this.slider.track?.details?.slides?.length;
      this.arrowDisabled = this.slider.track?.details?.slides?.length <= this.activeSliders;
    },
    centerArrows() {
      const { container } = this.$refs;
      if (!container) return;
      const { content } = this.$refs;
      const { brandSlideImageWrap, brandSlideArrow, disabled } = this.$style;
      const imageHeight = content
        ?.querySelector(`.${brandSlideImageWrap}`)
        .offsetHeight;
      const arrowHeight = container
        .querySelector(`.${brandSlideArrow}:not(.${disabled})`)
        ?.offsetHeight;
      const topPosition = (imageHeight - arrowHeight) / 2;
      container.querySelector(`.${this.$style.prev}`).style.top = `${topPosition}px`;
      container.querySelector(`.${this.$style.next}`).style.top = `${topPosition}px`;
    },
    loadFirstImg(index) {
      if (index) return;
      this.centerArrows();
      this.isImagesLoaded = true;
    },
    onResize: debounce(function scrollDebounce() {
      if (window.innerWidth < 1680 && this.activeSliders === 5) {
        this.activeSliders = 4;
        this.initSlider();
      } else if (window.innerWidth >= 1680 && this.activeSliders === 4) {
        this.activeSliders = 5;
        this.initSlider();
      }
      this.centerArrows();
    }, 100),
  },
  mounted() {
    this.$nextTick(() => {
      this.initSlider();
    });
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    if (this.slider) this.slider.destroy();
    window.removeEventListener('resize', this.onResize);
  },
};
